import * as React from 'react';

import { singleton } from 'logic/singleton';
import type { DataLakeInfoArray, DataLakeInfo } from 'data-lake/preview/Types';

export type ConfiguredDataLakesContextValue = {
  selectDataLake: React.Dispatch<React.SetStateAction<string>>;
  dataLakes: DataLakeInfoArray;
  selectedDataLake: DataLakeInfo;
};

const ConfiguredDataLakesContext = React.createContext<ConfiguredDataLakesContextValue>(undefined);
export default singleton('contexts.ConfiguredDataLakes', () => ConfiguredDataLakesContext);
